import Queue from './component'

export default {
  path: 'queue',
  element: <Queue />,
}
